import { inject, Injectable } from "@angular/core";
import { SearchParameters } from "@ramudden/models/search";
import { ITask, ITaskReassign, TaskCreator, TaskUpdater } from "@ramudden/models/task";
import { DownloadedFile, DownloadFileService } from "@ramudden/services";
import { Observable } from "rxjs";
import { ApiService, ApiServiceBase } from "./api";

@Injectable({
    providedIn: "root",
})
export class TaskApi extends ApiService<ITask, TaskCreator, TaskUpdater> {
    private readonly downloadFileService = inject(DownloadFileService);

    override getRoute(): string {
        return "Tasks";
    }

    exportToExcel$(searchParameters: SearchParameters): Promise<DownloadedFile> {
        const url = `${super.getUrl()}/ExportToExcel`;
        const parameters = new SearchParameters();
        parameters.queryParams = searchParameters;

        return this.downloadFileService.downloadBlob(
            url,
            null,
            null,
            ApiServiceBase.searchParametersToHttpParams(parameters),
        );
    }

    reassign$(taskReassign: ITaskReassign): Observable<void> {
        const url = `${super.getUrl()}/Reassign`;
        return this.http.post<void>(url, taskReassign);
    }
}
